import { Outlet } from 'react-router'
import Header from '../../../component/layout/header'
import useNav from '../../../component/custom-hooks/get-nav';

const PPCPerformanceOrganizationLayout = () => {

  const navList = useNav();
  let {PPCPerformanceTopNav, PPCPerformanceOrgBottomNav} = navList;

  return (
    <div className="webBody">
      <Header bottomTabs={PPCPerformanceOrgBottomNav} topTabs={PPCPerformanceTopNav} />
      <Outlet />
    </div>
  )
}

export default PPCPerformanceOrganizationLayout